import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, Skeleton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import ColorPalette from "../../color-palette/ColorPalette";
import { BackHand } from "@mui/icons-material";
import { getDataWithToken } from "../../services/GetDataService";
import { AuthContext } from "../../context/AuthContext";
import { jwtDecode } from "jwt-decode";

import { useSnackbar } from "notistack";

const style = {
  nav: {
    display: "flex",
    alignItems: "center",
    gap: 3,
    pb: 1,
    borderBottom: `1px solid ${ColorPalette.light.primary.light}`,
    width: "100%",
  },
  link: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: "4px",
  },
  linkActive: {
    cursor: "pointer",
    color: ColorPalette.light.primary.main,
    display: "flex",
    alignItems: "center",
    position: "relative",
    gap: 1,
    px: "4px",
    "&:before": {
      content: '""',
      width: "100%",
      height: "2px",
      backgroundColor: ColorPalette.light.primary.main,
      position: "absolute",
      bottom: -9,
      left: 0,
      right: 0,
    },
  },
  card: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 2,
    border: `1px solid ${ColorPalette.light.primary.light}`,
    backgroundColor: ColorPalette.light.text.bg,
    borderRadius: "8px",
    height: "100%",
    width: "100%",
    p: 2,
  },
  cardActive: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 2,
    border: `1px solid ${ColorPalette.light.primary.main}`,
    backgroundColor: ColorPalette.light.text.bg,
    borderRadius: "8px",
    height: "100%",
    width: "100%",
    p: 2,
  },
};

const TechnicianList = ({
  technician,
  setTechnician,

  technicianLoading,
  setTechnicianLoading,
  technicianList = [],
  setTechnicianList,
}) => {
  const { login, ifixit_admin_panel, logout } = useContext(AuthContext);

  const { enqueueSnackbar } = useSnackbar();
  // const [technicianList, setTechnicianList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const getBranchId = () => {
    let token = ifixit_admin_panel.token;
    let decodedToken = jwtDecode(token);
    let branch_id = decodedToken?.user?.branch_id;
    return branch_id;
  };

  // useEffect(() => {
  //   getBranchData();
  // }, []);
  // useEffect(() => {
  //   getTechnician();
  // }, [selectedBranch]);

  return (
    <div>
      <Grid container columnSpacing={3} sx={{}}>
        <Grid size={12}>
          <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
            Repair By
          </Typography>
        </Grid>
        {/* <Grid size={12}>
          <Box sx={style.nav}>
            {ifixit_admin_panel?.user?.is_main_branch &&
              branchList.length > 0 &&
              branchList.map((item, index) => (
                <Box
                  role="button"
                  sx={
                    selectedBranch === item._id ? style.linkActive : style.link
                  }
                  key={index}
                  onClick={() => setSelectedBranch(item._id)}
                >
                  {item.name}
                </Box>
              ))}
          </Box>
        </Grid> */}
      </Grid>
      <Grid container spacing={2} sx={{ mt: 3 }}>
        {!technicianLoading &&
          technicianList.length > 0 &&
          technicianList.map((item, index) => (
            <>
              <Typography
                variant="medium"
                sx={{ width: "100%", fontWeight: 600 }}
              >
                {item?.branch_data?.name}
              </Typography>
              {item?.users?.length > 0 &&
                item?.users?.map((item, i) => (
                  <Grid size={3} key={i}>
                    <Box
                      sx={
                        technician === item._id ? style.cardActive : style.card
                      }
                      role="button"
                      onClick={() => {
                        setTechnician(item._id);
                      }}
                    >
                      <Box>
                        <img
                          src={
                            item?.image?.url?.length > 0
                              ? item?.image?.url
                              : "/userpic.png"
                          }
                          alt=""
                          width="40px"
                          height="40px"
                          style={{
                            display: "block",
                            margin: "5px 0px",
                            borderRadius: "100px",
                            // border: "1px solid #d1d1d1",
                          }}
                        />
                      </Box>

                      <Box>
                        <Typography variant="medium">{item.name}</Typography>
                        <Typography
                          variant="small"
                          color="text.secondary"
                          sx={{ mt: "2px" }}
                        >
                          {item.designation}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
            </>
          ))}

        {!technicianLoading && message && (
          <Typography
            variant="h6"
            sx={{ textAlign: "center", mt: 4, width: "100%" }}
          >
            {message}
          </Typography>
        )}

        {technicianLoading && (
          <Grid size={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 3,
              }}
            >
              <Skeleton variant="rectangular" height={110} sx={{ flex: 1 }} />
              <Skeleton variant="rectangular" height={110} sx={{ flex: 1 }} />
              <Skeleton variant="rectangular" height={110} sx={{ flex: 1 }} />
              <Skeleton variant="rectangular" height={110} sx={{ flex: 1 }} />
            </Box>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default TechnicianList;
